export default {
  "pl": {
    "installment": {
      "actions": {
        "closeAllRows": "Zamknij wszystkie wiersze",
        "edit": "Edytuj",
        "newInstallment": "Nowy warunek dotyczący rat",
        "openAllRows": "Otwórz wszystkie wiersze",
        "publish": "Opublikuj",
        "publishCustomer": "Opublikuj…",
        "save": "Zaktualizuj",
        "unpublish": "Cofnij publikację",
        "updateStatus": "Zaktualizuj status",
        "uploadInvoice": "Prześlij faktura"
      },
      "attributes": {
        "amount": "Kwota",
        "customer": "Klient",
        "due_date": "Termin",
        "paid_at": "Opłacono dnia",
        "status_deadline": "Status",
        "unit": "Jednostka"
      },
      "labels": {
        "changeStatusRequested": "Zmień Raty ze statusu „Wersja robocza” na „Wnioskowana”",
        "changeVisibility": "Zmień ustawienia widoczności…",
        "countEdit": "Zmień ratę dla 1 jednostki | Zmień ratę dla następującej liczby jednostek: {count}",
        "created_at": "Utworzono: {created_at}",
        "details": "Szczegóły",
        "editDueDate": "Zmień termin",
        "editInstallmentTerm": "Zmień ratę",
        "giveNewAmount": "Podaj nową wartość",
        "goToUnitInstallments": "Raty jednostki",
        "invoices": "1 faktura | {count} faktury",
        "noDeadline": "Brak terminu",
        "notPublished": "Nie opublikowano",
        "paid": "Opłacono",
        "published": "Opublikowano",
        "publishedCustomer": "Opublikowano dla klienta",
        "publishingForCustomers": "Zamierzasz opublikować raty dla klienta. Czy na pewno chcesz to zrobić?",
        "setDueDate": "Określ termin",
        "statusExplained": "Co oznaczają poszczególne statusy rat?",
        "status_deadline": "Status",
        "statuses": {
          "draft": "Wersja wstępna",
          "expired": "Wygasły",
          "paid": "Opłacono",
          "requested": "Wymagana kwota"
        },
        "toBePaid": "Do zapłaty",
        "total": "Łącznie",
        "unitInstallmentsWillBeShownHere": "Tu będą widoczne raty jednostek",
        "unpublishingForCustomers": "Zamierzasz cofnąć publikację rat dla klienta. Czy na pewno chcesz to zrobić?",
        "updateStatusCount": "Zaktualizuj status 1 raty | Zaktualizuj status następującej liczby rat: {count}",
        "uploadInvoiceCount": "Prześlij fakturę za 1 raty | Prześlij fakturę za następującą liczbę rat: {count}",
        "uploadInvoiceUnit": "Prześlij fakturę do {unit_name}",
        "vat": "VAT",
        "vat_with_percentage": "",
        "view_cards": "Siatka"
      },
      "legend": {
        "installmentDraft": "Rata w wersji wstępnej",
        "installmentExpired": "Termin upłynął",
        "installmentPaid": "Rata została już opłacona",
        "installmentPaidAfterDue": "Rata opłacona po upływie terminu",
        "installmentRequested": "Wymagana rata"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Nowe raty pojawią się wkrótce!"
          }
        }
      },
      "validation": {
        "needNumber": "Należy podać liczbę (np. 8400,5)"
      }
    }
  }
}
